// Signup Verification
export const OTPSessionID = 'idn-verification';
// Reset Password
export const ResetPasswordSessionID = 'idn-reset-password';
export const ForceChangeTemporaryPasswordSessionID = 'idn-force-change-temporary-password';

// OTP Activity
export const OTPActivityVerifiedUser = 'verified-user';
export const OTPActivityForgotPassword = 'forgot-password';
